"use client";

import { SmartLink } from "@/Components";
import { DemoSiteTemplatesSectionProps } from "@/Templates/SectionsProps";
import { Icon } from "@iconify/react";
import { Card, Col, Empty, Image, Row, Typography } from "antd";
import { FC } from "react";

const DemoSiteTemplates: FC<DemoSiteTemplatesSectionProps> = ({
  dataSource,
}) => {
  const items = dataSource.Items;

  if (!items.length) {
    return (
      <section className="section">
        <div className="container">
          <Empty />
        </div>
      </section>
    );
  }

  return (
    <section className="section">
      <div className="container">
        <Row gutter={[16, 16]}>
          {items.map((item) => (
            <Col key={item.Id} xs={24} sm={12} lg={6}>
              <SmartLink
                href={item.Path ?? "#"}
                style={{ display: "block", height: "100%" }}
              >
                <Card
                  hoverable
                  cover={
                    item.ImageUrl ? (
                      <Image
                        height={200}
                        alt={item.Title}
                        src={item.ImageUrl}
                        preview={false}
                        style={{ objectFit: "cover" }}
                      />
                    ) : (
                      <Icon
                        height={200}
                        icon="streamline-plump-color:graphic-template-website-ui"
                      />
                    )
                  }
                  style={{ height: "100%", borderRadius: 8 }}
                  styles={{
                    body: {
                      // height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      gap: 12,
                    },
                  }}
                >
                  <Typography.Title
                    level={4}
                    style={{ margin: 0, textAlign: "center" }}
                  >
                    {item.Title}
                  </Typography.Title>
                  {/* <Typography.Text type="secondary" ellipsis={{ tooltip: item.Path }}>
                                        {item.Path}
                                    </Typography.Text> */}
                </Card>
              </SmartLink>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default DemoSiteTemplates;
